import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ImageIcon } from "lucide-react";

interface DrillPreviewDialogProps {
  drill: any | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const DrillPreviewDialog = ({ drill, open, onOpenChange }: DrillPreviewDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle>Drill Preview</DialogTitle>
        </DialogHeader>
        <div className="mt-4">
          {drill?.preview_image_url ? (
            <div className="flex flex-col gap-4">
              <div className="w-full h-[400px] relative rounded-lg overflow-hidden bg-gray-50">
                <img
                  src={drill.preview_image_url}
                  alt="Drill preview"
                  className="w-full h-full object-contain"
                />
              </div>
              <p className="text-gray-600 mt-4 whitespace-pre-wrap">
                {drill.description}
              </p>
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-8 text-gray-500">
              <ImageIcon className="h-12 w-12 opacity-20 mb-4" />
              <p>No preview image available</p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};